"use strict";

var _defineProperty = require("/home/circleci/repo/node_modules/gatsby/node_modules/@babel/runtime/helpers/defineProperty");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.StyledIcon = exports.CardSignpostBody = exports.CardSignpostTitle = exports.CardSignpostContent = void 0;

var _styled = _interopRequireDefault(require("@emotion/styled"));

var _sharedStyle = require("../../../styles/sharedStyle");

var _Card = require("./Card.style");

var _mediaQueries = _interopRequireDefault(require("../../../styles/mediaQueries"));

var _Icon = _interopRequireDefault(require("../../Icon"));

var CardSignpostContent = (0, _styled.default)(_Card.CardContent)(function (_ref) {
  var _ref2;

  var image = _ref.image,
      _ref$theme = _ref.theme,
      cards = _ref$theme.cards,
      space = _ref$theme.space;
  return _ref2 = {
    display: 'flex',
    alignItems: 'flex-start',
    height: 'inherit',
    flexWrap: cards.contentFlexWrap,
    padding: "".concat(space[cards.paddingTopBottom], " ").concat(space[cards.paddingLeftRight]),
    backgroundColor: cards.backgroundColor,
    '&:hover': {
      backgroundColor: cards.hoverBackgroundColor
    }
  }, _defineProperty(_ref2, _mediaQueries.default.medium, {
    height: image ? cards.heightWithImgTablet : cards.heightNoImgTablet
  }), _defineProperty(_ref2, _mediaQueries.default.large, {
    height: image ? '7rem' : cards.heightNoImgDesktop
  }), _defineProperty(_ref2, _mediaQueries.default.xlarge, {
    height: image ? '9rem' : cards.heightNoImgWide
  }), _ref2;
});
exports.CardSignpostContent = CardSignpostContent;
var CardSignpostTitle = (0, _styled.default)('h3')(function (_ref3) {
  var _ref3$theme = _ref3.theme,
      colors = _ref3$theme.colors,
      cards = _ref3$theme.cards;
  return _objectSpread({
    fontFamily: cards.fontFamily,
    fontSize: '1.8rem',
    lineHeight: '2rem',
    paddingRight: cards.paddingLeftRight,
    margin: '0'
  }, (0, _sharedStyle.textHover)({
    color: colors[cards.titleColor],
    width: '0',
    textDecoHover: cards.textDecoHoverSignPost
  }));
});
exports.CardSignpostTitle = CardSignpostTitle;
var CardSignpostBody = (0, _styled.default)('div')(function (_ref4) {
  var _ref4$theme = _ref4.theme,
      cards = _ref4$theme.cards,
      space = _ref4$theme.space;
  return {
    marginTop: space.xlarge,
    color: cards.bodyTextColor
  };
});
exports.CardSignpostBody = CardSignpostBody;
var StyledIcon = (0, _styled.default)(_Icon.default)(function (_ref5) {
  var space = _ref5.theme.space;
  return {
    position: 'absolute',
    right: space.small,
    transform: 'rotate(-90deg) translateX(7px)'
  };
});
exports.StyledIcon = StyledIcon;